// extracted by mini-css-extract-plugin
module.exports = {"timePassed":"TimePassed_timePassed__1Ka_y"};